import { render, staticRenderFns } from "./HeaderStudent.vue?vue&type=template&id=347ddaff&"
import script from "./HeaderStudent.vue?vue&type=script&lang=js&"
export * from "./HeaderStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports